import React, { Fragment } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { Typography, Tooltip } from '@mui/material';
import { downloadFile } from '#action/download';
import { createTitle } from '#component/shipment/form/cargo/cargo-item/helper';
import { showCargoItemTitle, showCargo, getDimensionsInfo, getWeightInfo } from './helper';
import {
  Title,
  SubTitle,
  InfoCtn,
  InfoItem,
  InfoItemContent,
  LinkStyle,
  Nodata
} from './styles';

const ShipmentInfo = ({ shipment = {} }) => {
  const dispatch = useDispatch();
  const { cargo, customFields, files, id } = shipment;
  const showCargoInfo = cargo?.some(c => showCargo(c));
  const measurementSystem = useSelector(s => s.account?.measurementSystem, shallowEqual);

  const handleDownloadFile = file => {
    dispatch(downloadFile(`shipment/${id}/file/${file?.id}`, `${file?.name}`));
  };

  if (!showCargoInfo && !customFields?.length && !files?.length) {
    return (
      <Nodata>
        <Typography variant="h4" gutterBottom>
          No data
        </Typography>
      </Nodata>
    );
  }

  return (
    <InfoCtn>
      {(cargo?.length && showCargoInfo) ?
        <InfoItem>
          <Title>Cargo</Title>
          {cargo.map((c, index) => (showCargo(c) ? (
            <Fragment key={c.id}>
              <InfoItemContent>
                <SubTitle variant="subtitle2">
                  {`${index + 1}. ${showCargoItemTitle(c) ? createTitle(c.goods, c.container) : ''}`}
                </SubTitle>
                {c.goods && <Typography>{`Product: ${c.goods}`}</Typography>}
                {c.description && <Typography>{`Description: ${c.description}`}</Typography>}
                {c.container && <Typography>{`Package type: ${c.container}`}</Typography>}
                {c.length && c.width &&
                  <Typography>{getDimensionsInfo(c, measurementSystem)}</Typography>}
                {c.weight && <Typography>{`Package weight: ${getWeightInfo(c.weight, measurementSystem)}`}</Typography>}
                {Boolean(c.fragile) && <Typography>Fragile</Typography>}
                {Boolean(c.hazmat) && <Typography>Hazmat</Typography>}
              </InfoItemContent>
            </Fragment>
          ) : null))}
        </InfoItem> : null}
      {customFields?.length ?
        <InfoItem>
          <Title>Custom fields</Title>
          {customFields.map((cf, index) => (
            <Fragment key={cf.id}>
              <InfoItemContent>
                {customFields.length > 1 ?
                  <SubTitle variant="subtitle2">
                    {`Field #${index + 1}`}
                  </SubTitle> : null}
                <Typography>
                  {cf.value ? `${cf.label}: ${cf.value}` : cf.label}
                </Typography>
              </InfoItemContent>
            </Fragment>
          ))}
        </InfoItem> : null}
      {files?.length ?
        <InfoItem>
          <Title>Documents</Title>
          {files.map((f, i) => (
            <Fragment key={f.id}>
              <InfoItemContent>
                {files.length > 1 ?
                  <SubTitle variant="subtitle2">
                    {`Document #${i + 1}`}
                  </SubTitle> : null}
                <Typography>{f.name}</Typography>
                {f.description && <Typography>{`File description: ${f.description}`}</Typography>}
                <Tooltip title="Download file">
                  <LinkStyle
                    onClick={() => handleDownloadFile(f)}
                    onKeyDown={() => handleDownloadFile(f)}
                    role="button"
                    tabIndex={0}
                  >
                    Download file
                  </LinkStyle>
                </Tooltip>
              </InfoItemContent>
            </Fragment>
          ))}
        </InfoItem> : null}
    </InfoCtn>
  );
};

export default ShipmentInfo;
